

































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import * as moment from 'moment';
import _ from 'lodash';
import ViewDetail from '../inventory/general-inventory-report-detail.vue'
class  PageGeneralInventoryReportRequest{
    warehouseCode :string;
    keyword:string;
    clientCode: string;
    assetTypeCode: string;
    conditionTypeCode : string;
    fromDate?:Date;
    toDate?:Date;
    endingBalance:number=0;
    pageSize:number;
    pageNumber:number;
    periodIncurred:boolean=false;
}
 @Component({
  components:{ 'view-detail': ViewDetail }
})
export default class GeneralInventoryReport extends mixins(ListMixin, AbpBase){
   namespace = 'generalInventoryReport';
    get store(){
            return this.$store.state.generalInventoryReport;
    }
    get sumInfo()
    {
      return this.store.sumInfo;
    }
    //filters
    pagerequest:PageGeneralInventoryReportRequest=new PageGeneralInventoryReportRequest();
    creationTime:Date[]=[];
    reportResult = [];
    assetTypes=[];
    conditionTypes=[];
    clients=[];
    spinShow:boolean=false;
    warehouses=[];
    viewModalShow:boolean=false;
    viewDateWarning(){ 
      var argus = [AppConsts.reportRangeDays.range180.toString()];
      return Util.L('RangeDaysTooltip','',...argus);
    }
    get totalBeginningBalance()
    {
        return this.sumInfo.totalBeginningBalance;
    }
   get totalBeginningPrice()
    {
        return this.sumInfo.totalBeginningPrice;
    }
    get totalInboundQty()
    {
        return this.sumInfo.totalInboundQty;
    }
    get totalInboundPrice()
    {
        return this.sumInfo.totalInboundPrice;
    }
    get totalOutboundQty()
    {
        return this.sumInfo.totalOutboundQty;
    }
    get totalOutboundPrice()
    {
        return this.sumInfo.totalOutboundPrice;
    }
    get totalEndingBalance()
    {
        return this.sumInfo.totalEndingBalance;
    }
    get totalEndingPrice()
    {
        return this.sumInfo.totalEndingPrice;
    }
    isClient() {
      return this.$store.state.session.client != null;
    }
    get clientCode() {
      return this.$store.state.session.client.code
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }
    get warehouseCode() {
      return this.$store.state.session.tenant.tenancyName;
    }
    async getClients(){
        if(this.isClient())
        {
          this.pagerequest.clientCode = this.clientCode;
        }
        else
        {
            await this.$store.dispatch({
                type:'client/getListForSelect'
            }).then(async result=>{
                var re = this.$store.state.client.clientsForSelect;
                this.$set(this.pagerequest, 'clientCode', re.length === 0 ? "" : re[0].code);
                this.clients= re;
            });
        }
        await this.changeClientCode();
    }
    async  getWarehouses(){
       if(this.isTenant())
        {
          this.pagerequest.warehouseCode = this.warehouseCode;
          return;
        }
       await this.$store.dispatch({
            type:'warehouse/getListForSelect'
        }).then(result=>{
           var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(this.pagerequest, 'warehouseCode', re.length === 0 ? "" : re[0].id);
        this.warehouses= re;
        });
    }
     async changeClientCode(){
        if(Util.isNull(this.pagerequest.clientCode) || Util.isEmpty(this.pagerequest.clientCode))
            return;
        await this.getClientAssetTypes();
    }
    async getConditionTypes()
    {
         await this.$store.dispatch({
            type:'masterData/getFeatureConditionTypesForSelect',
            data: { featureCode : AppConsts.featureConditionType.Report,hasAllItem: true}
        }).then(re=>{
          this.conditionTypes = re;
          this.pagerequest.conditionTypeCode = this.conditionTypes.length === 0 ? "" : this.conditionTypes[0].id;
        });
    }
    async getClientAssetTypes(){
         await this.$store.dispatch({
                type:'client/getClientAssetTypeServices',
                data:this.pagerequest.clientCode
            }).then(result => {
                var re = this.$store.state.client.clientAssetTypes;
                re.unshift({id : AppConsts.allItemValue, displayName: this.L(AppConsts.All)});
                this.$set(this.pagerequest, 'assetTypeCode', re.length === 0 ? "" : re[0].id);
                this.assetTypes= re;
        });
    }
    convertValueLessThanZero(value)
    {
        if(Util.isEmpty(value.toString()))
          return value;
        var decimalValue = parseFloat(value);
        if( Util.isNull(decimalValue))
        {
            return 0;
        }
        decimalValue = decimalValue<0? 0: decimalValue;
        return decimalValue;
    }
    async exportToExcel () {
     this.preGetPage();
      await this.$store.dispatch({
        type: `${this.namespace}/exportGeneralInventory`,
        data: this.pagerequest
      });
    }
    preGetPage()
    {
      this.pagerequest.endingBalance = +this.pagerequest.endingBalance;
      if (this.creationTime.length>0) {
            this.pagerequest.fromDate= this.creationTime[0];
        }
        if (this.creationTime.length>1) {
            this.pagerequest.toDate=this.creationTime[1];
        }
        this.pagerequest.pageSize = this.pageSize;
        this.pagerequest.pageNumber = this.currentPage;
    }
    
    async search()
    {
      this.$store.commit(`${this.namespace}/setCurrentPage`,1);
      await this.getpage();
    }
    async getpage() {
      this.preGetPage();
      await this.$store.dispatch({
        type: `${this.namespace}/getAll`,
        data: this.pagerequest
      })
      .catch(() => {
        this.store.loading = false;
      });
    }
    viewDetail(value:any,type:string)
    {
        this.preGetPage();
        var param = {
            productName:value.name,
            sku: value.sku,
            assetTypeName:value.assetTypeName,
            conditionTypeName:value.conditionTypeName,
            type: type,
            fromDate:this.pagerequest.fromDate,
            toDate:this.pagerequest.toDate,
            pagerequest:{
              warehouseCode: this.pagerequest.warehouseCode,
              productId: value.productId,
              assetTypeCode : value.assetTypeCode,
              conditionTypeCode : value.conditionTypeCode,
              type: type,
              fromDate:this.pagerequest.fromDate,
              toDate:this.pagerequest.toDate,
              pageNumber:1,
              pageSize: this.pagerequest.pageSize
            }
        };
        this.$store.commit('generalInventoryReportDetail/refreshListData');
        this.$store.commit(`${this.namespace}/view`, param );
        this.viewModalShow = true;
    }
    get columns()
    {
      return [
         {
            title:Util.L('SKU'),
            width:150,
            key:'sku'
        },{
            title:Util.L('ExternalCode'),
            width:150,
            key:'accountingSKU'
        },{
            title: Util.L("ProductName"),
            width:200,
            key:'name'
        },{
            title: Util.L("Unit"),
            width:100,
            key:'unitName'
        },
        {
            title:Util.L('AssetType'),
            width:150,
            key:'assetTypeName'
        },{
            title:Util.L('ConditionType'),
            width:150,
            key:'conditionTypeName'
        },
        {
            title: Util.L('BeginningPeriod'), 
            align: "center",
            children:
            [
              {
                    title: `${Util.L('Qty')} (${Util.toViewNumberString(this.totalBeginningBalance)})`, 
                     width:100,
                    key:'beginningBalance',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.beginningBalance));
                    }
                },
                {
                    title: `${Util.L('Value')} (${Util.toViewNumberString(this.totalBeginningPrice)})`, 
                    width:100,
                    key:'beginningPrice',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.beginningPrice));
                    }
                }
            ]
          
        },{
            title: Util.L('DashboardInboundQty'), 
            align: "center",
            children:
            [
              {
                    title: `${Util.L('Qty')} (${Util.toViewNumberString(this.totalInboundQty)})`, 
                    width:100,
                    slot:'inboundQty',
                    align: "right"
                },
                {
                    title: `${Util.L('Value')} (${Util.toViewNumberString(this.totalInboundPrice)})`, 
                    width:100,
                    key:'inboundPrice',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.inboundPrice));
                    }
                }
            ]
          
        },{
            title: Util.L('DashboardOutboundQty'), 
            align: "center",
            children:
            [
              {
                    title: `${Util.L('Qty')} (${Util.toViewNumberString(this.totalOutboundQty)})`, 
                    width:100,
                    slot:'outboundQty',
                    align: "right"
                },
                {
                    title: `${Util.L('Value')} (${Util.toViewNumberString(this.totalOutboundPrice)})`, 
                    width:100,
                    key:'outboundPrice',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.outboundPrice));
                    }
                }
            ]
          
        },{
            title: Util.L('EndingPeriod'), 
            align: "center",
            children:
            [
              {
                    title: `${Util.L('Qty')} (${Util.toViewNumberString(this.totalEndingBalance)})`, 
                    width:100,
                    key:'endingBalance',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.endingBalance));
                    }
                },
                {
                    title: `${Util.L('Value')} (${Util.toViewNumberString(this.totalEndingPrice)})`, 
                    width:100,
                    key:'endingPrice',
                    align: "right",
                    render: (h: any, params: any) => {
                        return h("span", Util.toViewNumberString(params.row.endingPrice));
                    }
                }
            ]
          
        }

      ];
    }
    refreshListData()
    {
      this.$store.commit(`${this.namespace}/refreshListData`);
    }
    async created(){
      this.refreshListData();
      this.spinShow = true;
      try {
        await  this.getClients();
        await this.getWarehouses();
        await this.getConditionTypes();
         var toMoment = moment();
         var currentDay = +toMoment.format('D');
        var fromMoment = moment().subtract((currentDay-1), "d");
        var toDate = new Date(toMoment.format(AppConsts.reportDateFormat));
        var fromDate = new Date(fromMoment.format(AppConsts.reportDateFormat));
        this.creationTime = [fromDate,toDate];
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
    }
}
